export const EXPERIENCE = [
  {
    company: 'BlackCowTech',
    role: 'Senior Software Engineer',
    period: 'Mar 2023 – Present',
    industry: 'iGaming (RGS)',
    logo: '/logos/blackcowtech.webp',
    points: [
      'Contributed to the world\u2019s first Multiplayer Server for RGS (Python, ECS) — 1,000+ daily users, 1B+ bets/year',
      'Built microservices with WebSockets, REST, and Hasura GraphQL for real-time applications',
      'Integrated DevOps tools into CI/CD pipeline, saving 1,300+ engineering hours/year across 400+ projects',
      'Deep SQL optimization using OTLP (OpenTelemetry), profiling, and visual analysis',
      'Built automated reporting dashboards via Hasura GraphQL for data-driven decisions',
    ],
  },
  {
    company: 'Swetrix',
    role: 'Co-Founder',
    period: 'Sep 2021 – Present',
    industry: 'GDPR Web Analytics',
    logo: '/logos/swetrix.webp',
    points: [
      'Architected and scaled the platform to handle 1M+ requests/second with high availability',
      'Led a team of 5 developers with effective product frameworks and communication',
      'Grew client base to 1,200+ weekly visits and 50+ active paying users',
      'Built Swetrix-AI-Prophet for time-series traffic predictions',
      'Implemented integrations (Slack, Discord, MS Teams), uptime monitoring, and e-commerce',
    ],
  },
  {
    company: 'Microsass Ltd',
    role: 'Senior Software Engineer',
    period: 'Aug 2022 – Mar 2023',
    industry: 'Dynamic Rental System',
    logo: '/logos/microsaas.webp',
    points: [
      'Supervised feature delivery and issue resolution in a live production system',
      'Developed a custom dynamic SQLAlchemy ORM framework',
      'Implemented comprehensive testing strategies and CI/CD pipelines',
    ],
  },
  {
    company: 'ElephantsLab',
    role: 'Middle Software Engineer',
    period: 'Jan 2021 – Mar 2022',
    industry: 'Meta Universe / NFT',
    logo: '/logos/elephantslab.webp',
    points: [
      'Developed Python backend (Unity frontend) for Meta Universe project with NFT characters',
      'Delivered core game logic, API layers, and AI-driven character behaviors',
      'Built socket-based microservices for real-time communication (DRF + FastAPI)',
      'Gained initial management experience in product development',
    ],
  },
];
